import React from "react";
import styles from "./DashBorder.module.scss";

const DashBorder = ({ sideMargins, inner }) => {
    // sideMargins MARGIN FOR DASH LINE TO HAVE FROM BOTH EDGES OF DEVICE (in px)
    return (
        <div className={styles.dashBorder} style={inner ? {} : { margin: `0 ${sideMargins || 0}px` }}>
            <div className={styles.dashBorder__line} style={inner ? {
                marginLeft: `${sideMargins}px`,
                width: `calc(100% - ${sideMargins * 2}px)`
            } : {}}></div>
        </div>
    )
}

export default DashBorder;